import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import pickBy from 'lodash/pickBy';
import Layout from '@/Shared/Layout';
import throttle from 'lodash/throttle';
import mapValues from 'lodash/mapValues';
import Pagination from '@/Shared/Pagination';
import SearchFilter from '@/Shared/SearchFilter';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Pagination: Pagination,
    SearchFilter: SearchFilter
  },
  layout: Layout,
  props: {
    queues: Object,
    jobs: Array
  },
  methods: {
    getHealthClass: function getHealthClass(required, current) {
      return {
        'pill active': required == current,
        'pill pause': required > current && current != 0,
        'pill suspend': current == 0
      };
    }
  }
};